import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { UiModalComponent } from '@components';
import { ModalResultType } from '@models';
import { SettingService } from '@services';

export enum LicenseUpdateType {
    Online = 'Online',
    Offline = 'Offline',
}

@Component({
    templateUrl: './update.modal.html',
    providers: [
        SettingService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UpdateModalComponent
    extends UiModalComponent<boolean> {

    public online() {
        this._dialogRef.close({
            type: ModalResultType.Update,
            additionalData: LicenseUpdateType.Online,
        });
    }

    public offline() {
        this._dialogRef.close({
            type: ModalResultType.Update,
            additionalData: LicenseUpdateType.Offline,
        });
    }
}
